export default "__VITE_ASSET__Cg96sdcW__"